"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.createMockSocket = exports.resultMock = exports.bulkSocketMock = exports.secureChannelMock = exports.withSocketErrors = exports.socketErrorSubject = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
exports.socketErrorSubject = new rxjs_1.Subject();
var withSocketErrors = function (observable) {
    return (0, rxjs_1.merge)(observable, exports.socketErrorSubject.pipe((0, operators_1.mergeMap)(function (e) { return (0, rxjs_1.throwError)(e); })));
};
exports.withSocketErrors = withSocketErrors;
var pause = function (ms) { return (0, rxjs_1.interval)(ms).pipe((0, operators_1.take)(1), (0, operators_1.ignoreElements)()); };
var secureChannelMock = function (managerGranted) {
    if (managerGranted === void 0) { managerGranted = false; }
    return !managerGranted
        ? (0, rxjs_1.concat)(pause(500), (0, rxjs_1.of)({
            type: "device-permission-requested",
            wording: "Ledger manager"
        }), pause(500), (0, rxjs_1.of)({
            type: "device-permission-granted"
        }), pause(500))
        : pause(1000);
};
exports.secureChannelMock = secureChannelMock;
var bulkSocketMock = function (duration) {
    if (duration === void 0) { duration = 1000; }
    var total = Math.floor((duration - 100) / 100);
    return (0, rxjs_1.interval)(100).pipe((0, operators_1.take)(total + 1), (0, operators_1.map)(function (index) { return ({
        type: "bulk-progress",
        progress: index / total,
        index: index,
        total: total
    }); }));
};
exports.bulkSocketMock = bulkSocketMock;
var resultMock = function (payload) {
    return (0, rxjs_1.of)({
        type: "result",
        payload: payload
    });
};
exports.resultMock = resultMock;
var createMockSocket = function () {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return (0, exports.withSocketErrors)(rxjs_1.concat.apply(void 0, __spreadArray([], __read(observables), false)));
};
exports.createMockSocket = createMockSocket;
//# sourceMappingURL=socket.mock.js.map